import * as ApiAdapterUtils from '../../../../apiAdapter/utils';
import { ApiTypeEnum } from '../../../constants';
/**
 *
 */
export const putCharacterDescriptionAge = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/age');
/**
 *
 */
export const putCharacterDescriptionAlignment = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/alignment');
/**
 *
 */
export const putCharacterDescriptionEyes = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/eyes');
/**
 *
 */
export const putCharacterDescriptionFaith = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/faith');
/**
 *
 */
export const putCharacterDescriptionGender = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/gender');
/**
 *
 */
export const putCharacterDescriptionHair = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/hair');
/**
 *
 */
export const putCharacterDescriptionHeight = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/height');
/**
 *
 */
export const putCharacterDescriptionLifestyle = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/lifestyle');
/**
 *
 */
export const putCharacterDescriptionName = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/name');
/**
 *
 */
export const putCharacterDescriptionNotes = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/notes');
/**
 *
 */
export const putCharacterDescriptionSkin = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/skin');
/**
 *
 */
export const putCharacterDescriptionTraits = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/traits');
/**
 *
 */
export const putCharacterDescriptionWeight = ApiAdapterUtils.makePut(ApiTypeEnum.CHARACTER_SERVICE, 'description/weight');
